import React, { Suspense, useEffect, useRef, useState } from 'react';
import { dataSection, formatTime } from '../../../contant';
import { useNavigate, useParams } from 'react-router-dom';
import { pageRoutes } from '../../../routes/pageRoutes';
import { APIServices } from '../../../hooks/fetchAPI';
import { FaQuestion } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { Warning } from 'postcss';

const ExamList = React.lazy(() => import('./ExamList'));
const ExamTab = React.lazy(() => import('./ExamTab'));
const Instructions = React.lazy(() => import('./Instructions'));
const ExamDashboard = React.lazy(() => import('./ExamDashboard'));
const FaqModal = React.lazy(() => import('../Modal/FaqModal'));
const WarningNotif = React.lazy(() => import('../Modal/WarningNotif'));

const Exam = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setLoading] = useState(false);
    const [examList, setExamList] = useState(null);
    const [ref_ID, setRefID] = useState();
    const [showDashboard, setShowDashboard] = useState(true);
    const [selectedExam, setSelectedExam] = useState(null);
    const [shuffledSections, setShuffledSections] = useState([]);
    const [activeStep, setActiveStep] = useState(parseFloat(id));
    const [timeLeft, setTimeLeft] = useState(0); // Timer state
    const [start, setStart] = useState(false);
    const [finish, setFinish] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [totalItem, setTotal] = useState(null);
    const [examContent, setExamContent] = useState(null);
    const [verbalContent, setverbalContent] = useState(null);
    const [mockTitle, setMockTitle] = useState(null);
    const [passageContent, setPassageContent] = useState(null);
    const [audioContent, setAudioContent] = useState(null);
    const [verbalTypeID, setVerbalTypeID] = useState(null);
    const hasFetched = useRef(false);
    const [showFaq, setShowFaq] = useState(false);
    const user = useSelector((state) => state.user.userData)
    const [isTabActive, setIsTabActive] = useState(true);
    const [switchCount, setSwitchCount] = useState(0);
    const [openWarning, setOpenWarning] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [mediaError, setMediaError] = React.useState(null);



    React.useEffect(() => {
        if (!showDashboard) return;
        const checkPermissions = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: {
                        width: { ideal: 854 },
                        height: { ideal: 480 },
                        frameRate: { ideal: 30, max: 30 }
                    }
                });
                stream.getTracks().forEach(track => track.stop()); // Stop tracks immediately after getting permission
                setMediaError(null);
            } catch (err) {
                setMediaError('Please allow access to your microphone and camera to proceed with the exam.');
                setShowModal(true); // Automatically open the setup modal on error
            }
        };
        checkPermissions();
    }, [showDashboard]);


    useEffect(() => {
        if (user.exam_status !== 'pending' || user.exam_attempts === '0/3') {
            navigate(pageRoutes.APPLICANT);
        }
    }, [user]);


    useEffect(() => {
        hasFetched.current = false;
        handleExamClick()

    }, [id]);

    useEffect(() => {
        mainAPI();
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        if (finish) {
            navigate(`/personality-exam/1}`);
        }
    }, [finish]);

    useEffect(() => {
        if (selectedExam && !hasFetched.current) {
            fetchContent();
            hasFetched.current = true;
        }
    }, [selectedExam]);

    useEffect(() => {
        setActiveStep(parseFloat(id) - 1);
        if (examList?.data?.length > 0) {
            const examId = parseFloat(id);
            const exam = examList.data.find((section) => section.reference_order === examId ?? 1);
            setRefID(exam?.id)
            setSelectedExam(exam);
        }
        if (shuffledSections.length > 0 && id) {
            const examId = parseFloat(id);
            const exam = shuffledSections.find((section) => section.reference_order === examId);
            const index = shuffledSections.findIndex((section) => section.reference_order === examId);
            setRefID(exam?.id)
            setSelectedExam(exam);
            setActiveStep(index);
        }
    }, [id, examList, activeStep, selectedExam, shuffledSections]);

    useEffect(() => {
        if (examList?.data?.length > 0) {
            const sections = [...examList.data];
            setShuffledSections(sections);
        }
    }, [examList]);

    useEffect(() => {
        handleFinish();
    }, [activeStep]);

    useEffect(() => {
        if (
            user?.completedSectionIds &&
            Array.isArray(user.completedSectionIds) &&
            user.completedSectionIds.includes(parseFloat(id))
        ) {
            const nextSection = shuffledSections.find(
                (section) => !user.completedSectionIds.includes(section.reference_order)
            );
            if (nextSection) {
                navigate(`/assessment/exam/${(parseFloat(id)) + 1}`);
            } else {
                navigate(pageRoutes.APPLICANT);
            }
        }
    }, [id, user, shuffledSections, navigate]);

    useEffect(() => {
        let snapshotInterval;
        if (!finish && start) {
            let snapshotCount = 0;
            const maxSnapshots = Math.floor(Math.random() * 3) + 5;

            const takeSnapshotLoop = () => {
                if (snapshotCount < maxSnapshots && !finish) {
                    captureSnapshot();
                    snapshotCount++;
                    const nextDelay = (Math.random() * 300 + 300) * 1000;
                    snapshotInterval = setTimeout(takeSnapshotLoop, nextDelay);
                }
            };
            takeSnapshotLoop();
        }
        return () => {
            if (snapshotInterval) clearTimeout(snapshotInterval);
        };
    }, [finish, start]);

    const mainAPI = async () => {
        try {
            const response = await APIServices.get({ url: `/exam-types` });


            if (response && response.status === 200) {
                setExamList(response?.data?.data?.examTypes);
                setShuffledSections(response?.data?.data?.examTypes);

            } else {
                console.error("Failed to fetch exam types:", response);
            }
        } catch (error) {
            console.error("Error fetching exam types:", error);
        }
        if (!id) {

        }
    }

    const fetchContent = async () => {
        setLoading(false)
        if (!selectedExam?.category?.tag) return;

        let response;
        switch (selectedExam.category.tag) {
            case 'mcqs':
                response = await APIServices.get({ url: `/mcq-user/fetch-exam` });
                if (response.status === 200) {
                    const examId = parseInt(id, 10);

                    const examcontent = response?.data?.data?.find((section) => section?.exam_type_id === ref_ID);
                    const localPassageId = examcontent?.questions[0]?.passage_id || null;
                    const localAudioID = examcontent?.questions[0]?.audio_id || null;

                    const passageContent = response?.data?.passage_groups?.find((section) => section?.passage_id === localPassageId);
                    const audioContent = response?.data?.audio_groups?.find((section) => section?.audio_id === localAudioID);

                    if (examcontent && Array.isArray(examcontent.questions)) {
                        setPassageContent(passageContent ?? null);
                        setAudioContent(audioContent ?? null)
                        setTotal(examcontent?.questions?.length);
                        setExamContent(examcontent);
                        if (examContent) {
                            setLoading(true)
                        }
                    } else {
                        setTotal(0);
                        setExamContent(null);
                    }

                } else {
                    setTotal(0);
                    setExamContent(null);
                }
                break;
            case 'asmc':
                //4- Verbal, 7- Moc
                // k
                if (selectedExam?.reference_order === 5) {
                    response = await APIServices.get({ url: `/verbal/fetch-verbal-content` }, {
                        payload: {
                            "is_active": true
                        }
                    });
                    if (response.status === 200) {
                        setverbalContent(response?.data?.data);
                        setTotal(response?.data?.data?.length || 0);
                        setVerbalTypeID(selectedExam?.id)
                        if (verbalContent) {
                            setLoading(true)
                        }
                    } else {
                        setverbalContent(null);
                        setTotal(0);
                    }
                } else if (selectedExam?.reference_order === 6) {
                    response = await APIServices.get({ url: `/mock/fetch-mock-content` }, {
                        payload: {
                            "is_active": true
                        }
                    });
                    if (response.status === 200) {
                        setverbalContent(response?.data?.data[0]?.mock_content);
                        setMockTitle(response?.data?.data[0]?.mock_call_content_name);
                        setTotal(response?.data?.data[0]?.mock_content?.length || 0);
                        setVerbalTypeID(selectedExam?.id)
                        if (verbalContent) {
                            setLoading(true)
                        }
                    } else {
                        setTotal(0);
                        setverbalContent(null);
                    }

                } else {
                    return;
                }
                break;
            case 'wpm':
                response = await APIServices.get({ url: `/wpm/fetch-wpm-content` });
                if (response.status === 200) {
                    setTotal(1)
                    setLoading(true)
                } else {
                    setTotal(0)
                }
                break;

            default:
                return;
        }
    }

    const handleStart = () => {
        setStart(true);
        setTimeLeft(selectedExam?.allotted_time * 60);
    };

    const handleExamClick = () => {
        const examId = parseFloat(id);
        const exam = shuffledSections.find((section) => section.reference_order === examId);
        const index = shuffledSections.findIndex((section) => section.reference_order === examId);
        setSelectedExam(exam);
        setActiveStep(index);
        setSidebarOpen(false);
    };

    const handleNextStep = () => {

        if (activeStep < shuffledSections.length - 1) {
            const nextStep = parseFloat(activeStep) + 1;
            navigate(`/assessment/exam/${parseFloat(id) + 1}`)
            setActiveStep(parseFloat(id) + 1);
            setSelectedExam(shuffledSections[nextStep]);
        }
    };

    const handleFinish = () => {

        if (parseFloat(id) === 9) {
            return setFinish(true);
        } else {
            return setFinish(false);
        }
    };

    const captureSnapshot = async () => {
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: { ideal: 854 },
                    height: { ideal: 480 },
                    frameRate: { ideal: 30, max: 30 }
                }
            });
            const track = stream.getVideoTracks()[0];
            const imageCapture = new ImageCapture(track);

            const blob = await imageCapture.takePhoto();

            const formData = new FormData();

            formData.append('user_id', user?.id);
            const now = new Date();
            const timestamp = now.toISOString().replace(/[:.]/g, '-');
            const filename = `ss_${user?.id}_${formatTime(timestamp)}.png`;
            formData.append('snap_shot_file', blob, filename);

            const response = await APIServices.post({
                url: `/snapShot`,
                payload: formData,
            });

            if (response && response.status === 201) {
                console.log("Snapshot logged successfully:");
            } else {
                console.error("Failed to log exam time:", response);
            }
        } catch (err) {
            console.error("Error capturing snapshot:", err);
        } finally {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        }
    };

    const handleVisibilityChange = async () => {
        if (document.hidden) {
            setIsTabActive(false);
            setSwitchCount((prev) => prev + 1);
            setOpenWarning(true);

            const response = await APIServices.post({
                url: `/switch-tabs`,
                payload: { "section_id": 2 },
            });

            if (response && response.status === 201) {
                console.log("User switched tab!");
            } else {
                console.error("Failed to log:", response);
            }

            // console.log(" User switched tab!");
        } else {
            setIsTabActive(true);
            // console.log("User returned to exam tab.");
        }
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpenWarning(false);
    };


    return (
        <div className="h-screen flex flex-col md:flex-row overscroll-none">
            <Suspense fallback={<div></div>}>
                <FaqModal visible={showFaq} onClose={() => setShowFaq(false)} />
                <WarningNotif
                    open={openWarning}
                    onClose={handleClose}
                    switchCount={switchCount}
                />
            </Suspense>
            {showDashboard ? (
                <Suspense fallback={<div></div>}>
                    <ExamDashboard
                        showDashboard={showDashboard}
                        setShowDashboard={setShowDashboard}
                        handleExamClick={handleExamClick}
                        showModal={showModal}
                        setShowModal={setShowModal}
                    />
                </Suspense>
            ) : (
                <>
                    {/* Mobile Sidebar Toggle */}
                    <div className="md:hidden flex items-center justify-between p-4 bg-white shadow">
                        <button
                            className="text-gray-700 focus:outline-none"
                            onClick={() => setSidebarOpen(!sidebarOpen)}
                            aria-label="Open sidebar"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                        <span className="font-semibold text-lg">Assessment Exam</span>
                    </div>

                    {/* Sidebar */}
                    <div
                        className={`
                            fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-md transform
                            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
                            transition-transform duration-200 ease-in-out
                            md:static md:translate-x-0 md:w-1/4 lg:w-1/6 md:block
                        `}
                        style={{ maxHeight: '100vh' }}
                    >
                        <Suspense fallback={<div></div>}>
                            <ExamList
                                sections={shuffledSections}
                                shuffledSections={shuffledSections}
                                activeStep={activeStep}
                                setActiveStep={setActiveStep}
                                handleNextStep={handleNextStep}
                            />
                        </Suspense>

                    </div>
                    <div className='flex flex-row h-fit bg-white shadow-sm rounded-md absolute top-4 right-4 p-2 gap-2 items-center justify-center'>
                        <Suspense fallback={<div></div>}>
                            <FaQuestion />
                        </Suspense>
                        <span onClick={() => setShowFaq(true)} className='text-[#388E3C] font-semibold cursor-pointer hover:text-[#556fa8]'>FAQ's</span>
                    </div>
                    {/* Overlay for mobile sidebar */}
                    {sidebarOpen && (
                        <div
                            className="fixed inset-0 bg-black bg-opacity-30 z-20 md:hidden"
                            onClick={() => setSidebarOpen(false)}
                        />
                    )}

                    {/* Exam Content */}
                    <Suspense fallback={<div></div>}>
                        <div className="flex-1 overflow-auto ">
                            {
                                start ? (
                                    <ExamTab
                                        selectedExam={selectedExam}
                                        onFinish={handleNextStep}
                                        handleStart={handleStart}
                                        timeLeft={timeLeft}
                                        setTimeLeft={setTimeLeft}
                                        start={start}
                                        setStart={setStart}
                                        handleFinish={finish}
                                        totalItem={totalItem}
                                        examContent={examContent}
                                        passageContent={passageContent}
                                        audioContent={audioContent}
                                        verbalContent={verbalContent}
                                        mockTitle={mockTitle}
                                        verbalTypeID={verbalTypeID}
                                        isLoading={isLoading}
                                    />
                                ) : (
                                    <Instructions
                                        id={id}
                                        data={selectedExam}
                                        type={selectedExam?.name}
                                        Instructions={selectedExam?.category?.description}
                                        minutes={selectedExam?.allotted_time}
                                        start={start}
                                        handleStart={handleStart}
                                        setStart={setStart}
                                        total={selectedExam?.questions_count || 0}
                                    />
                                )
                            }
                        </div>
                    </Suspense>

                </>
            )
            }
        </div >
    );
};

export default Exam;
